var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E8E13F",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9168 13.0002C20.9168 13.9748 21.3949 14.8378 22.1294 15.3675C21.3927 16.0865 20.7797 16.6512 20.2235 17.0756C19.3689 17.7276 18.7222 17.9892 18.0508 17.9892C17.3795 17.9892 16.7327 17.7276 15.8781 17.0756C15.0091 16.4126 14.0016 15.4069 12.6002 14.0055L11.8124 13.2177C12.242 12.5616 12.8484 12.0397 13.562 11.7125C14.3888 11.3335 15.4176 11.3335 17.4751 11.3335H18.8286C19.9435 11.3335 20.7563 11.3335 21.3987 11.3938C21.0941 11.8545 20.9168 12.4066 20.9168 13.0002Z",
    fill: "#E8E13F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.213 15.5706C24.8022 15.7915 24.3325 15.9168 23.8335 15.9168C23.6821 15.9168 23.5334 15.9053 23.3883 15.8831C22.4684 16.7925 21.6906 17.5286 20.9818 18.0694C20.016 18.8062 19.1054 19.2392 18.0508 19.2392C16.9963 19.2392 16.0857 18.8062 15.1199 18.0694C14.1763 17.3495 13.1104 16.2835 11.7501 14.9233L11.3021 14.4752C11.1454 15.1131 11.031 15.937 10.8718 17.083C10.5083 19.7001 10.3266 21.0086 10.7262 22.0249C11.077 22.9171 11.7248 23.661 12.5602 24.1312C13.5119 24.6668 14.8329 24.6668 17.4751 24.6668H18.8286C21.4707 24.6668 22.7918 24.6668 23.7435 24.1312C24.5789 23.661 25.2267 22.9171 25.5775 22.0249C25.9771 21.0086 25.7954 19.7001 25.4319 17.083C25.3512 16.502 25.282 16.0038 25.213 15.5706Z",
    fill: "#E8E13F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5002 13.0002C25.5002 13.9206 24.754 14.6668 23.8335 14.6668C22.913 14.6668 22.1668 13.9206 22.1668 13.0002C22.1668 12.0797 22.913 11.3335 23.8335 11.3335C24.754 11.3335 25.5002 12.0797 25.5002 13.0002Z",
    fill: "#E8E13F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow);
export default __webpack_public_path__ + "static/media/yellow.60e61aa1.svg";
export { ForwardRef as ReactComponent };